// Startseiten-Abschnitte: Reihenfolge/Sichtbarkeit (settings.home_sections) + eigene Textfelder (settings.home_text_blocks)
export const HOME_SECTION_DEFS = [
  { id: "usps", label: "Vorteile-Kacheln", hint: "Sofortbuchung · Alle 8 Inseln · Bewertungen · Gutschein" },
  { id: "islands", label: "Die acht Inseln", hint: "Insel-Kacheln mit Bildern" },
  { id: "offers", label: "Angebots-Streifen", hint: "Aktive Angebote (Marketing → Angebote)", flag: "offers_show_home" },
  { id: "featured", label: "Ausgewählte Ferienobjekte", hint: "Objekte mit Häkchen „Empfohlen“", count: 3, max: 12 },
  { id: "complexes", label: "Fincas & Anlagen", hint: "Fincas und Anlagen mit mehreren Unterkünften als Kacheln, Link zur Übersicht /fincas-anlagen", count: 3, max: 12 },
  { id: "new", label: "Neu bei uns", hint: "Zuletzt online gegangene Objekte („Neu“-Tage in den Einstellungen)", flag: "new_home_strip", count: 3, max: 12 },
  { id: "last_minute", label: "Last-Minute-Angebote", hint: "Objekte mit Last-Minute-Rabatt", count: 6, max: 12 },
  { id: "places", label: "Beliebte Orte", hint: "Orte mit den meisten Online-Objekten als Linkliste auf die Ortsseiten (SEO)", count: 12, max: 40 },
  { id: "reviews", label: "Bewertungen", hint: "Ausgewählte Gästestimmen", count: 3, max: 12 },
  { id: "tips", label: "Reisetipps", hint: "Die neuesten Reisetipps (Menü-Seiten) als Kacheln", count: 3, max: 12 },
  { id: "faq", label: "Häufige Fragen (FAQ)", hint: "Fragen & Antworten mit FAQ-Schema für Google – über „Bearbeiten“ pflegen", editable: true },
  { id: "recent", label: "Zuletzt angesehen", hint: "Nur für Besucher mit Verlauf", count: 8, max: 12 },
];
const DEF_BY_ID = Object.fromEntries(HOME_SECTION_DEFS.map((d) => [d.id, d]));

export const isTextSection = (id) => (id || "").startsWith("text:");
export const textBlockId = (id) => id.slice(5);
export const HEADING_LEVELS = ["h1", "h2", "h3", "h4", "h5"];
/** Eigene Blöcke: kind "heading" = alleinstehender Titel (H1–H5), sonst Textfeld (Fließtext). */
export const isHeadingBlock = (b) => b?.kind === "heading";

/** Gespeicherte Reihenfolge mit Standard-Abschnitten und Textfeldern zusammenführen; `on` berücksichtigt Einzel-Schalter (offers_show_home, new_home_strip); `count` = Anzahl Einträge (Admin). */
export const resolveHomeSections = (settings = {}) => {
  const blocks = settings.home_text_blocks || [];
  const known = new Set([...HOME_SECTION_DEFS.map((d) => d.id), ...blocks.map((b) => `text:${b.id}`)]);
  const list = (settings.home_sections || []).filter((s) => s && known.has(s.id)).map((s) => ({ id: s.id, on: s.on !== false, ...(Number(s.count) > 0 ? { count: Number(s.count) } : {}) }));
  const have = new Set(list.map((s) => s.id));
  HOME_SECTION_DEFS.forEach((d) => { if (!have.has(d.id)) list.push({ id: d.id, on: true }); });
  blocks.forEach((b) => { if (!have.has(`text:${b.id}`)) list.push({ id: `text:${b.id}`, on: true }); });
  return list.map((s) => { const flag = DEF_BY_ID[s.id]?.flag; return flag ? { ...s, on: settings[flag] !== false } : s; });
};

/** Anzahl der Einträge eines Abschnitts (gespeichert oder Standard). */
export const homeSectionCount = (settings, id) => {
  const def = DEF_BY_ID[id];
  const saved = (settings?.home_sections || []).find((s) => s?.id === id);
  const n = Number(saved?.count);
  return n > 0 ? Math.min(n, def?.max || 40) : (def?.count || 3);
};
